// extracted by mini-css-extract-plugin
export default {"list":"ExtraPurchaseFieldsView_list__w9qE-","inputField":"ExtraPurchaseFieldsView_inputField__FxYmT"};